import { render, staticRenderFns } from "./CustomActivityStatusBadge.vue?vue&type=template&id=090b35f7&scoped=true"
import script from "./CustomActivityStatusBadge.vue?vue&type=script&lang=js"
export * from "./CustomActivityStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b35f7",
  null
  
)

export default component.exports